<template>
  <div>
    <b-modal
      :id="modalName"
      hide-header
      hide-footer
      content-class="custom-border-radius-1-3"
      body-class="p-0"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-backdrop
      :size="size"
    >
      <b-overlay :show="wait" spinner-variant="success" spinner-type="grow" rounded="sm">
        <div class="modal-body-container" :style="'--height: ' + modalHeight + ';'">
          <div class="custom-header">
            <div v-html="highlight(score)"></div>
            <div class="header-text">{{ headerText }}</div>
          </div>
          <div class="custom-body">
            <div class="custom-content">
              <div class="lesson-name-style">
                <div class="item-style" v-for="(item, key) in lessonName" :key="key">
                  <div v-if="key < lessonName.length-1">
                    <span style="color: black">{{ item.label }}</span>
                    <span style="margin: 0px 10px;">></span>
                  </div>
                  <div v-else>
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </div>
              <div v-if="rows.length > 0" class="fields-alignment">
                <b-row
                  v-for="(row, index1) in rows"
                  :key="index1"
                  style="width:90%;margin-bottom:15px"
                >
                  <b-col
                    md="6"
                    sm="12"
                    v-for="(col, index2) in row"
                    :key="index1+'_'+index2"
                    class="col-style"
                  >
                    <span v-if="col" class="fields-style">{{ col.label }}</span>
                    <div v-if="col" v-html="highlight2(col.value, 16)"></div>
                  </b-col>
                </b-row>
              </div>
              <div v-if="extraText.length > 0" class="extra-text-style">
                {{ extraText }}
              </div>
              <div v-else class="extra-text-style">
                <slot name="extraText" />
              </div>
            </div>
            <div class="custom-footer">
              <slot name="buttons"></slot>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { highlightNumber } from '@/util/highlight.js'

const AchievementModal = Vue.extend({
  name: 'AchievementModal',
  props: {
    modalHeight: {
      type: String,
      default: 'auto'
    },
    modalName: {
      type: String,
      required: true,
      default: 'modal'
    },
    headerText: {
      type: String,
      required: true,
      default: ''
    },
    score: {
      type: String,
      required: true,
      default: ''
    },
    lessonName: {
      type: Array,
      required: true
    },
    extraText: {
      type: String,
      required: false,
      default: ''
    },
    wait: {
      type: Boolean,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      shown: false,
      rows: [],
      isDisplayScoreFullLarge: false
    }
  },
  computed: {
    displayScoreFullLarge () {
      return this.isDisplayScoreFullLarge
    }
  },
  methods: {
    showModal (infoFields = [], displayScoreFullLarge = false) {
      this.rows = []
      this.isDisplayScoreFullLarge = displayScoreFullLarge

      for (let i = 0; i < infoFields.length; i += 2) {
        this.rows.push([infoFields[i], infoFields[i + 1]])
      }
      this.$bvModal.show(this.modalName)
      this.shown = true
    },
    closeModal () {
      this.$bvModal.hide(this.modalName)
      this.shown = false
    },
    highlight (str) {
      let renderHtml = ''
      if (this.displayScoreFullLarge) {
        return `<span class="score-style" style="margin-top:10px;font-size:32px !important;">${str}</span>`
      }
      for (let i = 0; i < str.length; i++) {
        let ch = str.charAt(i)
        if ((ch >= '0' && ch <= '9') || ch === '.' || ch === '-') {
          renderHtml += `<span class="score-style">${ch}</span>`
        } else {
          renderHtml += `<span class="score-unitLabel-style">${ch}</span>`
        }
      }
      return renderHtml
    },
    highlight2 (str, fontSize = null) {
      return highlightNumber(str, fontSize)
    }
  }
})

export default AchievementModal
</script>

<style lang='scss' scoped>
.modal-body-container {
  height: var(--height);
}
.custom-header {
  padding: 0.5rem 0rem;
  border-top-left-radius: 1.3rem;
  border-top-right-radius: 1.3rem;
  background-color: #19847c;
  height: auto;
  text-align: center;
  font-weight: bolder;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-body {
  padding: 0.5rem 0rem;
  border-bottom-left-radius: 1.3rem;
  border-bottom-right-radius: 1.3rem;
  background-color: #ffffff;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-content {
  height: 70%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.lesson-name-style {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
}
.item-style {
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
}
.fields-alignment {
  margin: 10px 0px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.custom-footer {
  padding: 0.5rem 0rem;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  height: auto;
  color: #ffffff;
  font-size: 16px;
  font-weight: 200;
}
.col-style {
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.fields-style {
  display: flex;
  &.value {
    font-weight: 500;
  }
}
.extra-text-style {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
  font-weight: 500;
  font-size: 20px;
}
</style>
